export interface FormatTooltipValueOptions {
  // when omitted,integers stay integers and non integers round to 2 decimals
  decimals?: number;
  unit?: string;
  locale?: string | string[];
}

export function formatTooltipValue(
  value: number | string | null | undefined,
  options: FormatTooltipValueOptions = {}
): string {
  const { decimals, unit, locale } = options;

  if (value === null || value === undefined || value === '') return '—';

  const num = typeof value === 'number' ? value : Number(value);
  if (!Number.isFinite(num)) return String(value);

  const fractionDigits = decimals ?? (Number.isInteger(num) ? 0 : 2);

  const formatted = new Intl.NumberFormat(locale, {
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: fractionDigits,
  })
    .formatToParts(num)
    .map((part) => (part.type === 'group' ? ' ' : part.value))
    .join('');

  return unit ? `${formatted} ${unit}` : formatted;
}
